export default __webpack_public_path__ + "static/media/DMSans-Bold.ed4c3297.ttf";